const fieldLabels = {
  name: "Name",
  email: "Email",
  password: "Password",
  password_confirmation: "Confirm Password",
  branch_id: "Branch",
  subbranch_id: "Sub Branch",
  shift_id: "Shift",
  shift_ids: "Shifts",
  manager_id: "Manager",
  team_leader_id: "Team Leader",
  roles: "Role",
  "roles.0": "Role",
  user_code: "Employee Code",
  weekend_off: "Weekend Off",
  status: "Status",
  joining_date: "Joining Date",
  appointment_date: "Appointment Date",
  project_title: "Project Title",
  project_manager_id: "Project Management Team",
  project_manager_role_id: "Project Management Team",
  project_manager_role: "Project Management Team",
  project_type_id: "Study Type",
  project_type: "Study Type",
  project_type_option_id: "Project Type",
  project_type_option: "Project Type",
  client_id: "Client",
  vendor_ids: "Vendors",
  vendors: "Vendors",
  targeting: "Targeting",
  geo: "Geo",
  attachment_docs: "Attachment Docs",
  "attachment_docs.0": "Attachment Docs",
  "attachment_docs.*": "Attachment Docs",
  loi: "LOI(mins)",
  ir: "IR(%)",
  bid_cpi: "BID CPI",
  won_cpi: "WON CPI",
  required_n: "Required N",
  overall_quota: "Overall Completes Quota",
  overall_clicks_quota: "Overall Clicks Quota",
  country_quota: "Country Completes Quota",
  country_clicks_quota: "Country Clicks Quota",
  vendor_quota: "Vendor Completes Quota",
  vendor_clicks_quota: "Vendor Clicks Quota",
  feasibility: "Feasibility",
  required_field_time_days: "Required Field Time",
  project_launch_date: "Project Launch Date",
  comments: "Comments",
  "details.*.country_id": "Country/Geo",
  "details.*.targeting": "Targeting",
  "details.*.loi": "LOI(mins)",
  "details.*.ir": "IR(%)",
  "details.*.required_n": "Required N",
  "details.*.country_quota": "Country Completes Quota",
  "details.*.country_clicks_quota": "Country Clicks Quota",
  "details.*.vendor_quota": "Vendor Completes Quota",
  "details.*.vendor_clicks_quota": "Vendor Clicks Quota",
  "details.*.bid_cpi": "Bid CPI",
  "details.*.won_cpi": "Won CPI",
  "details.*.feasibility": "Feasibility",
  "details.*.required_field_time_days": "Required Field Time",
};

const normalizedFieldKey = (field) =>
  String(field || "")
    .replace(/\.\d+\./g, ".*.")
    .replace(/\.\d+$/g, ".*");

const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const fieldLabel = (field) =>
  fieldLabels[field] ||
  fieldLabels[normalizedFieldKey(field)] ||
  normalizedFieldKey(field)
    .replace(/\.\d+/g, "")
    .replace(/\.\*\./g, " ")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const cleanApiMessage = (field, message) => {
  const label = fieldLabel(field);
  const text = String(message);
  const exactField = escapeRegExp(field);
  const normalizedField = escapeRegExp(normalizedFieldKey(field));

  return text
    .replace(new RegExp(`The ${exactField} field`, "gi"), `The ${label} field`)
    .replace(new RegExp(`The ${normalizedField} field`, "gi"), `The ${label} field`);
};

export const apiErrorMessage = (payload, fallback = "Request failed") => {
  const errors = payload?.errors;

  if (errors && typeof errors === "object") {
    const messages = Object.entries(errors)
      .flatMap(([field, value]) => {
        const list = Array.isArray(value) ? value : [value];
        return list
          .filter(Boolean)
          .map((message) => `${fieldLabel(field)}: ${cleanApiMessage(field, message)}`);
      })
      .filter(Boolean);

    if (messages.length) {
      return messages.join(" ");
    }
  }

  if (payload?.message) return payload.message;
  if (payload?.error && typeof payload.error === "string") return payload.error;
  if (payload?.rawMessage) return payload.rawMessage;

  return fallback;
};

export const apiSuccessMessage = (payload, fallback = "Saved successfully") =>
  payload?.message || payload?.success_message || fallback;

export const readJsonSafely = async (response) => {
  const contentType = response.headers.get("content-type") || "";
  const text = await response.text();

  if (!text) return {};

  try {
    return JSON.parse(text);
  } catch {
    const rawMessage = text
      .replace(/<style[\s\S]*?<\/style>/gi, " ")
      .replace(/<script[\s\S]*?<\/script>/gi, " ")
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return {
      message: contentType.includes("text/html")
        ? "Server ne JSON response nahi bheja. Backend error/log check karo."
        : rawMessage,
      rawMessage: rawMessage.slice(0, 300),
    };
  }
};
